<template>
  <div class="modal-card" id="draggable">
    <header class="modal-card-head pop-header">
      <button class="icon is-right" @click="move" style="position:absolute;top:18px;right:70px;z-index:30;"><i class="fas fa-window-maximize" style="color:#fff;font-size:22px;padding-top:1px"></i></button>
      <p class="modal-card-title tit">
        권한별 사용자 내역
        <button class="btn-pop-close delete" aria-label="close" @click="$parent.close()"></button>
      </p>
    </header>
    <section class="modal-card-body pop-content">
      <div class="inner-box">
        <div class="content-name">
          <div class="btn-wrap btn-type1 clearfix" style="float: right;">
            <button class="btn-size btn-blue fl_left" @click="query">
              <span class="btn-icon"><i class="fas fa-search"></i></span>
              조회
            </button>
            <button class="btn-size btn-blue fl_left" @click="buttonClickEventSave()">
              <span class="btn-icon"><i class="fas fa-save"></i></span>
              저장
            </button>
          </div>
        </div>
        <br>
        <br>

        <div class="pop-content-search">
          <div class="field has-addons ">
            <div class="control is-expanded search-area">
              <div class="ip-box rs-mt2">
                <span class="NotoM" style="margin-right: 10px;">- 성명</span>
                <input class="input" type="text" v-model="name" @keydown.enter="query" style="padding-right:20px; width: 175px;">
                <button class="icon is-right" @click="query"><i class="fas fa-search"></i></button>
              </div>
            </div>
            <div class="control is-expanded search-area">
              <span class="NotoM" style="margin-right: 10px;">- 부서</span>
              <div class="ip-box rs-mt2">
                <input class="input" type="text" v-model="dept" @keydown.enter="query" style="padding-right:20px; width: 175px;">
                <button class="icon is-right" @click="query"><i class="fas fa-search"></i></button>
              </div>
            </div>
          </div>
        </div>

        <div class="table-area">
          <div class="table-b">
            <dhx-grid ref="grid" v-model="data" :config="config" @constructGridSuccessful="constructGridSuccessful" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import DhxGrid from '@/components/DhxGrid.vue'
  import GridCheckbox from '@/components/grid/GridCheckbox.vue'
  import AuthMngUserBu from '@/components/AuthMngUserBu.vue'
  export default {
    props: {
      'roleCd': {
        type: String,
        required: true
      },
      'compCd': {
        type: String,
        required: true
      }
    },
    components: {
      DhxGrid
    },
    data() {
      return {
        data: [],
        isMxMn: true,
        name: '',
        dept: '',
        config: {
          columns: [{
            value: 'No.',
            type: 'cntr',
            width: 50
          }, {
            id: 'roleChk',
            value: '권한부여',
            width: 60,
            type: 'ch'
            // component: GridCheckbox,
            // mixin: {
            //   data() {
            //     return {
            //       trueValue: '1',
            //       falseValue: '0'
            //     }
            //   }
            // }
          }, {
            id: 'crtRole',
            value: '현재권한'
          }, {
            id: 'empNo',
            value: '사번',
          }, {
            id: 'empNm',
            value: '성명',
          }, {
            id: 'dutNm',
            value: '직급',
          }, {
            id: 'deptNm',
            value: '부서',
            align: 'left'
          }, {
            value: '사업장권한',
            component: {
              template: `<div class="btn-wrapper" v-if="!value.new"><button type="button" class="btn btn-primary btn-block" @click="openModal()">선택</button></div>`,
              methods: {
                openModal() {
                  this.$modal.open({
                    component: AuthMngUserBu,
                    parent: this,
                    width: 1000,
                    props: {
                      empNo: this.value.empNo,
                      empNm: this.value.empNm,
                      compCd: this.value.compCd
                    }
                  })
                }
              }
            }
          }]
        }
      }
    },
    methods: {
      move(){
        if(this.isMxMn) {
          $(".modal-card").removeClass('pop_min')
          $(".modal-card").addClass('pop_max');

          $(".animation-content").removeClass('pop_min')
          $(".animation-content").addClass('pop_max');
          this.isMxMn = false
        } else {
          $(".modal-card").removeClass('pop_max')
          $(".modal-card").addClass('pop_min');

          $(".animation-content").removeClass('pop_max')
          $(".animation-content").addClass('pop_min');
          this.isMxMn = true
        }
      },
      constructGridSuccessful(grid) {},
      query() {
        this.$store.commit('loading')
        this.$http.get(`/api/auth/user`, {
          params: {
            roleCd: this.roleCd,
            compCd: this.compCd,
            value1: this.name,
            value2: this.dept
          }
        }).then(response => {
          this.data = response.data.map(x => {
            x.roleChk = x.roleChk === '1' ? true : false
            x.compCd = this.compCd
            return x
          })
        }).finally(() => {
          this.$store.commit('finish')
        })
      },
      buttonClickEventSave() {
        let data = _.cloneDeep(this.data).map(x => {
          delete x.children
          x.roleChk = x.roleChk ? '1' : '0'
          x.roleCd = this.roleCd
          x.compCd = this.compCd
          return x
        }).filter(x => x.roleChk === '1')
        this.$http.put(`/api/auth/user/${this.roleCd}/${this.compCd}`, data)
                .then(response => {
                  this.$emit('close')
                }).catch(response => {
          console.error(response)
        })
      }
    },
    created() {
      this.query()
    },
    mounted() {
      //pop slots modal move
      $(".animation-content").addClass('pop_min');
      $(".animation-content").draggable();
      //ModalSlot open z-index change
      $('.lnb').css('z-index', '4');
    },
    destroyed() {
      //ModalSlot open z-index change
      $('.lnb').css('z-index', '7');
    }
  }
</script>

<style scoped>
  .modal-card {
    width: auto;
  }
</style>